import { FlowSelectSourceType } from '@lighthouse/core'
import type { FindSingleRecordActionConfigure, FlowNodeResultADT } from '@lighthouse/shared'
import { type ActionFlowNode, getFindSingleRecordVariableValue, getRecordResult } from '@lighthouse/shared'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleFindSingleRecord = async (
    node: ActionFlowNode<FindSingleRecordActionConfigure>,
    params: ExecuteActionParams
): Promise<FlowNodeResultADT | undefined> => {
    const { actionEvents, upstreamNodesResult } = params
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const { dataSourceId, nodeId, selectType } = config

    if (selectType === FlowSelectSourceType.UPSTREAM) {
        const record = getRecordResult(upstreamNodesResult?.[nodeId])
        return {
            type: 'record',
            success: true,
            data: record
        }
    }

    if (!dataSourceId) {
        throw new Error(t('datasourceNotFound'))
    }

    const payload = getFindSingleRecordVariableValue(config, params)

    const record = await actionEvents.findSingleRecord(payload)

    return {
        type: 'record',
        success: true,
        data: record ?? undefined
    }
}
